import { render, staticRenderFns } from "./judge.vue?vue&type=template&id=c20e9310&scoped=true"
import script from "./judge.vue?vue&type=script&lang=js"
export * from "./judge.vue?vue&type=script&lang=js"
import style0 from "./judge.vue?vue&type=style&index=0&id=c20e9310&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20e9310",
  null
  
)

export default component.exports